import moment from 'moment';
import createMonthsMap from './createMonthsMap';

export const getMonthNames = (monthsCount) => {
  const monthMap = createMonthsMap(monthsCount);
  const monthNumbers = Array.from(monthMap.keys());

  return monthNumbers.map((monthNumber) => moment.monthsShort()[monthNumber]);
};